import { render, staticRenderFns } from "./CascadingElementScaleUnitTableColumn.vue?vue&type=template&id=115b943f"
import script from "./CascadingElementScaleUnitTableColumn.vue?vue&type=script&lang=js"
export * from "./CascadingElementScaleUnitTableColumn.vue?vue&type=script&lang=js"
import style0 from "./CascadingElementScaleUnitTableColumn.vue?vue&type=style&index=0&id=115b943f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports